/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SubscribeRequestBillingCadence = typeof SubscribeRequestBillingCadence[keyof typeof SubscribeRequestBillingCadence];


export const SubscribeRequestBillingCadence = {
  monthly: 'monthly',
  annual: 'annual',
} as const;
